<template>
  <div class="content-item flex">
    <div class="content-item-label">
      转载作者
    </div>
    <el-input
      class="item-input"
      placeholder="请输入转载作者出处..."
      v-model="input"
      :disabled="reprintedDisabled"
    ></el-input>
  </div>
</template>

<script>
export default {
  name: "reprintedFrom",
  props: ['reprintedFrom','reprintedDisabled'],
  computed: {
    input: {
      get() {
        return this.reprintedFrom
      },
      set(val) {
        this.$emit('update:reprintedFrom',val)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
